import Logo from "../../assets/imgs/swirepay-logo.svg";
import EmailIcon from "../../assets/imgs/email.svg";
import PhoneIcon from "../../assets/imgs/call.svg";
import SupportLine from "../../assets/imgs/SupportLine.png";
import BrndImg from "../../assets/imgs/brand.svg";
import LineSeperate from "../../assets/imgs/lineSeperate.png";
import React, { useEffect, useState } from "react";

type Props = {
  email: string,
  phone: string,
  partnerImageUrl: string,
  bankImageUrl: string,
  whiteLabel: boolean,
}

const Support = (props: Props) => {

  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');

  const isBlank = str => {
    return (!str || /^\s*$/.test(str));
  };

  useEffect(() => {
    if (!isBlank(props.email))
      setEmail(props.email);
    if (!isBlank(props.phone))
      setPhone(props.phone);
  }, [props.email, props.phone]);

  return (
    <footer className="footer">
      {
        props.email && props.phone && (
          <div className="mb-4" >
            <div className="text-muted" style={{ lineHeight: "20px" }}>
              <p>For any inquiries, please contact</p>
              <table>
                <tbody>
                  <tr>
                    <td className="pt-2">
                      <img style={{ verticalAlign: "middle" }} src={EmailIcon} alt="" className="pr-2" />
                      <span style={{ wordBreak: 'break-all' }}><a href={`mailto:${email}`}>{email}</a></span>
                    </td>
                  </tr>
                  <tr style={{ display: "block" }}>
                    <td className="pt-2">
                      <img style={{ verticalAlign: "middle" }} src={PhoneIcon} alt="" className="pr-2" />
                      <span style={{ wordBreak: 'break-all' }}><a href="#">{phone}</a></span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        )
      }
      {
        props.bankImageUrl && (
          <div className="mb-2" >
            <img src={props.bankImageUrl} style={{ paddingBottom: "8px", width: "125px" }} alt="" />
          </div>
        )
      }
      {
        (props.whiteLabel === true) ? '' : (
          <div className="container-fluid text-muted px-0">
            <a href="https://www.swirepay.com" target="_blank" >
              <img src={BrndImg} className="pr-2" style={{ paddingBottom: "8px", width: "125px" }} alt="" />
            </a>
          </div>
        )
      }
    </footer>
  )
};

export default Support;